import { CoinInfo } from '../context/coin_context'
import { get, post, put } from './generic'

export interface CreateCoinInterface {
    nome: string
    iso: string
    path_imagem: string
    simbolo: string
    flag_esconder_decimal: number
}

export interface CoinApiData {
    id_moeda: number
    nome: string
    flag_ativo: number
    iso: string
    path_imagem: string
    simbolo: string
    flag_esconder_decimal: number
    cambiosOrigem?: {
        id_cambio: number
        id_moeda_origem: number
        id_moeda_destino: number
        cotacao_compra: number
        cotacao_venda: number
        flag_cambio_reverso: number
        flag_deletado: number
        data_cadastro: Date
        moedaDestino: CoinApiData
    }[]
}

export interface UpdateCoinInterface extends Partial<CreateCoinInterface> {
    id_moeda: number
    exchanges?: {
        id_moeda_origem: number
        id_moeda_destino: number
        cotacao_compra: number
        cotacao_venda: number
        flag_cambio_reverso: number
    }[]
}

export function parseCoin(data: CoinApiData): CoinInfo {
    return {
        id: data.id_moeda,
        name: data.nome,
        iso: data.iso,
        symbol: data.simbolo,
        pathImage: data.path_imagem,
        hideDecimal: Boolean(data.flag_esconder_decimal),
        exchanges: data.cambiosOrigem
            ? data.cambiosOrigem.map((co) => ({
                  buyExchange: Number(co.cotacao_compra),
                  saleExchange: Number(co.cotacao_venda),
                  flagReverseExchange: co.flag_cambio_reverso,
                  coin: parseCoin(co.moedaDestino),
                  date: new Date(co.data_cadastro),
              }))
            : [],
    }
}

export async function createCoin(data: CreateCoinInterface): Promise<void> {
    await post('currency', data, {
        useRecaptcha: true,
    })
}

export async function listCoins(): Promise<CoinInfo[]> {
    const res = await get('currency')
    return res.data.data.map((data: CoinApiData) => parseCoin(data))
}

export async function updateCoin(data: UpdateCoinInterface): Promise<void> {
    await put('currency', data, {
        useRecaptcha: true,
    })
}
